// CAT元素路径
const CATList = [
    'https://img001.aivideo8.com/colour/social-networks/60469.svg',
    'https://img001.aivideo8.com/colour/social-networks/19318.svg',
    'https://img001.aivideo8.com/colour/social-networks/19318.svg',
    'https://img001.aivideo8.com/colour/social-networks/32323.svg',
    'https://img001.aivideo8.com/colour/social-networks/16713.svg',
    'https://img001.aivideo8.com/colour/social-networks/13983.svg',
    'https://img001.aivideo8.com/colour/social-networks/118497.svg',
    'https://img001.aivideo8.com/colour/social-networks/108794.svg',
    'https://img001.aivideo8.com/colour/social-networks/19977.svg',
    'https://img001.aivideo8.com/colour/social-networks/13976.svg',
    'https://img001.aivideo8.com/colour/social-networks/13975.svg',
    'https://img001.aivideo8.com/colour/social-networks/13642.svg',
    'https://img001.aivideo8.com/colour/social-networks/118640.svg',
    'https://img001.aivideo8.com/colour/social-networks/114452.svg',
    'https://img001.aivideo8.com/colour/social-networks/114450.svg',
    'https://img001.aivideo8.com/colour/social-networks/114445.svg',
    'https://img001.aivideo8.com/colour/social-networks/114441.svg',
    'https://img001.aivideo8.com/colour/social-networks/13912.svg',
    'https://img001.aivideo8.com/colour/social-networks/108794.svg',
]
export default {
    // 判断有没CAT元素
    hasCATElement(state) {
        const list = []
        state.fragments.forEach(item => {
            item.effects.forEach(id => {
                if (state?.effects[id]?.content?.src) {
                    list.push(state.effects[id].content.src)
                }
            })
        })
        for (let i of list) {
            const index =CATList.findIndex(item => item==i)
            if (index>-1) {
                return true
            }
        }
        return false
    }
}